import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListLeads from '../../lead/list-leads';
import Header from '../../common/components/header';
import Sidebar from '../../common/components/sidebar';

const LeadRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/" element={<ListLeads />} />
          </Routes>
        </div>
      </div>

      <>Some Footer Stuff</>
    </>
  );
};

export default LeadRoutes; 